module.exports = __webpack_public_path__ + "media/images/pic/popup/popup-desktop-bg-439269292284a2515a63fe2451a68828.png";